import React, { useState, ChangeEvent } from 'react';
import { FaSave } from 'react-icons/fa';
import Dates from '~/utils/dates';
import CurrencyInput from '~/components/Modules/CurrencyMask';
import './styles.css';

interface AddTeAclModalProps {
    unit: number;
    defaultYear?: number;
    defaultMonth?: number;
    onSave: (data: { year: number; month: number; price: number }) => void;
    onCancel: () => void;
}

const AddTeAclModal: React.FC<AddTeAclModalProps> = ({ unit, defaultYear, defaultMonth, onSave, onCancel }) => {
    const currentDate = new Date();

    const [formData, setFormData] = useState({
        year: typeof defaultYear === 'number' ? defaultYear : currentDate.getFullYear(),
        month: typeof defaultMonth === 'number' ? defaultMonth : (currentDate.getMonth() + 1),
        price: 0
    });

    function onChange(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    function onChangeFloat(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, originalValue: any) {
        const { name } = event.target;
        setFormData(prev => ({ ...prev, [name]: originalValue }));
    }

    function getMonths() {
        let ret: any = [];
        for (let i = 0; i <= 11; i++) {
            let item = {
                month: i + 1,
                name: Dates._getNameMonth(i)
            };
            ret.push(item);
        }
        return ret;
    }

    function getYears() {
        let init = Number(Dates.getYear()),
            ret: any = [];
        for (let i = init; i >= (init - 20); i--) {
            ret.push(i);
        }
        return ret;
    }

    function handleSave() {
        if (!formData.price || Number(formData.price) <= 0) {
            alert('Por favor, insira um montante válido.');
            return;
        }
        onSave({ year: Number(formData.year), month: Number(formData.month), price: Number(formData.price) });
    }

    return (
        <div className="price-modal-container">
            <div className="price-modal-header">
                <h3>Adicionar TE/ACL</h3>
            </div>

            <div className="price-modal-body">
                <div className="form-group">
                    <label htmlFor="year">Ano:</label>
                    <select
                        id="year"
                        name="year"
                        value={formData.year}
                        onChange={onChange}
                        className="form-select"
                    >
                        {getYears().map((year: any) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="month">Mês:</label>
                    <select
                        id="month"
                        name="month"
                        value={formData.month}
                        onChange={onChange}
                        className="form-select"
                    >
                        <optgroup label="Meses">
                            {getMonths().map((month: any) => (
                                <option key={month.month} value={month.month}>
                                    {month.name}
                                </option>
                            ))}
                        </optgroup>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="price">Montante (MWh):</label>
                    <CurrencyInput
                        id="price"
                        name="price"
                        placeholder="0,00000"
                        onChangeValue={onChangeFloat}
                        value={formData.price}
                        hideSymbol
                        digits={5}
                        className="form-input"
                    />
                </div>
            </div>

            <div className="price-modal-footer">
                <button className="btn-cancel" onClick={onCancel}>
                    Cancelar
                </button>
                <button className="btn-save" onClick={handleSave}>
                    <FaSave size={16} />
                    Adicionar
                </button>
            </div>
        </div>
    );
};

export default AddTeAclModal;


